// Public contact details: https://ainiiku-church.com/law/
// Nationwide visits: https://ainiiku-church.com/profile/
export const pastors = [
  {
    id: 'ishikawa-tomomi',
    name: '石川有生（ともみん）',
    church: '会いに行くキリスト教会',
    // Classification supplied by the site owner.
    faithCategory: 'プロテスタント',
    email: 'phy.tomo8@gmail.com',
    phone: '070-8427-5324',
    phoneHref: 'tel:07084275324',
    phoneHours: '10:00〜17:00',
    region: '神奈川県茅ヶ崎市（全国訪問・オンライン対応）',
    contactUrl: 'https://ainiiku-church.com/contact/',
  },
  {
    id: 'shindo-tatsuya',
    name: '進藤龍也',
    church: '［罪人の友］主イエス・キリスト教会',
    // Church's stated classification: https://tsumitomo-church.com/
    faithCategory: 'プロテスタント（単立）',
    // Church contact: https://tsumitomo-church.com/contact/
    // Updated number: https://tsumitomo-church.com/2025-0131-3507/
    email: 'jesus.tsumitomo@gmail.com',
    phone: '048-201-9665',
    phoneHref: 'tel:0482019665',
    phoneHours: null,
    region: '埼玉県川口市',
    contactUrl: 'https://tsumitomo-church.com/pastor-introduction/',
  },
];
